import { useCallback, useState } from "react";

import {
  loginUserEmailPassword,
  registerUser,
  resetPassword as forgetPassword,
  changePassword,
  loginWithGoogle,
  loginWithApple,
} from "@/firebase/auth";
import { authErrorHandler } from "@/lib/firebaseErrorHandler";

export const useAuthHook = () => {
  const [authError, setAuthError] = useState<string>("");

  const loginWithPassword = useCallback(
    async (email: string, password: string) => {
      const emailValue = email.trim();
      const passwordValue = password.trim();

      return await loginUserEmailPassword({
        email: emailValue,
        password: passwordValue,
      }).catch((error) => setAuthError(authErrorHandler(error)));
    },
    [],
  );

  const signupWithPassword = useCallback(
    async (fullname: string, email: string, password: string) => {
      const emailValue = email.trim();
      const passwordValue = password.trim();

      return await registerUser({
        email: emailValue,
        password: passwordValue,
        name: fullname,
      }).catch((error) => setAuthError(authErrorHandler(error)));
    },
    [],
  );

  const resetPassword = useCallback(async (email: string) => {
    const emailValue = email.trim();
    return await forgetPassword(emailValue);
  }, []);

  const updatePassword = useCallback(
    async (oldPassword: string, newPassword: string) => {
      return await changePassword(oldPassword, newPassword).catch((error) =>
        setAuthError(authErrorHandler(error, "updatePassword")),
      );
    },
    [],
  );

  const signinWithGoogle = useCallback(async () => {
    return await loginWithGoogle().catch((error) =>
      setAuthError(authErrorHandler(error)),
    );
  }, []);

  const signinWithApple = useCallback(async () => {
    return await loginWithApple().catch((error) =>
      setAuthError(authErrorHandler(error)),
    );
  }, []);

  return {
    authError,
    setAuthError,
    signinWithGoogle,
    signinWithApple,
    loginWithPassword,
    signupWithPassword,
    resetPassword,
    updatePassword,
  };
};
